module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.showdHeader ? 'padBox' : '', 'contain']
  }, [(_vm.showdHeader) ? _c('x-header', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "top": "0",
      "z-index": "30"
    },
    attrs: {
      "left-options": {
        backText: '',
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": _vm.backHome
    }
  }, [_vm._v("谷町君分享會")]) : _vm._e(), _vm._v(" "), (_vm.ndata == 0) ? _c('div', {
    staticClass: "noAccessbox"
  }, [_c('Empty'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "font-size": "14px",
      "color": "#44c2b8",
      "line-height": "40px"
    },
    on: {
      "click": _vm.tolist
    }
  }, [_vm._v("查看所有分享會")])], 1) : _vm._e(), _vm._v(" "), (_vm.ndata == 1) ? _c('div', {
    staticClass: "meetDetail"
  }, [_c('div', {
    staticClass: "coverBox",
    style: ({
      height: _vm.bacheight,
      backgroundImage: 'url(' + _vm.meetingDetail.meetingCoverImage + ')',
      maxHeight: '200px'
    })
  }), _vm._v(" "), (!_vm.showdHeader) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "width": "25px",
      "height": "25px",
      "background": "#ffffffc2",
      "border-radius": "50%",
      "border": "1px solid #44c2b8",
      "left": "10px"
    },
    on: {
      "click": _vm.backHome
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "size": "25",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "25",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.ifproject) ? _c('div', {
    staticClass: "detaildesBox",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "meetTit",
    staticStyle: {
      "font-size": "1.7rem",
      "font-weight": "bold",
      "line-height": "2rem"
    }
  }, [(_vm.weekend) ? _c('span', [_vm._v("NO." + _vm._s(_vm.meetingDetail.meetingNumber) + " ")]) : _vm._e(), _vm._v(_vm._s(_vm.meetingDetail.meetingName))]), _vm._v(" "), _c('van-cell', {
    staticClass: "meetTit",
    attrs: {
      "border": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v(_vm._s(_vm.meetingDetail.cost) + " 日元 （約" + _vm._s(_vm.meetingDetail.cost_rmb) + "元）")]), _vm._v(" "), _c('van-icon', {
    staticClass: "custom-icon",
    attrs: {
      "slot": "icon",
      "color": "#44c2b8",
      "size": "18px",
      "name": "question-o"
    },
    on: {
      "click": _vm.getCostdes
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('van-icon', {
    staticClass: "custom-icon",
    attrs: {
      "slot": "icon",
      "size": "20px",
      "name": "gold-coin"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('van-cell', {
    staticClass: "meetTit",
    attrs: {
      "title": _vm.meetingDetail.meetingTime,
      "border": false
    }
  }, [_c('van-icon', {
    staticClass: "custom-icon",
    attrs: {
      "slot": "icon",
      "size": "20px",
      "name": "clock"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('van-cell', {
    staticClass: "meetTit",
    attrs: {
      "title": _vm.meetingDetail.meetingType ? _vm.meetingDetail.meetingAddress : '在線',
      "border": false
    }
  }, [_c('van-icon', {
    staticClass: "custom-icon",
    attrs: {
      "slot": "icon",
      "size": "20px",
      "name": "location"
    },
    slot: "icon"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ifproject) ? _c('div', {
    staticClass: "detaildesBox",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "meetTit",
    staticStyle: {
      "font-size": "1.7rem",
      "font-weight": "bold",
      "line-height": "2rem",
      "padding-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.meetingDetail.meetingName))]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    staticStyle: {
      "font-size": "1.4rem",
      "margin-top": "6px",
      "margin-bottom": "6px"
    }
  }, [_c('pre', {
    staticStyle: {
      "margin": "0",
      "white-space": "pre-wrap",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.meetingDetail.meetingDesc))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.ifproject) ? _c('div', {
    staticClass: "descBox"
  }, [_c('group', [_c('cell', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d2d2d",
      "font-weight": "bold"
    },
    attrs: {
      "title": "分享會簡介",
      "is-link": "",
      "border-intent": false,
      "arrow-direction": "down"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDes = !_vm.showDes
      }
    }
  }), _vm._v(" "), (_vm.showDes) ? [_c('cell-box', {
    staticClass: "sub-item",
    staticStyle: {
      "font-size": "15px",
      "color": "grey",
      "line-height": "22px"
    },
    attrs: {
      "border-intent": false
    }
  }, [_vm._v(_vm._s(_vm.meetingDetail.meetingDesc))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "padding-top": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": "https://img.gutingjun.com/meeting/meeting_bottom.png",
      "alt": ""
    }
  })])] : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.meetingDetail.contentList && _vm.meetingDetail.contentList.length) ? _c('div', {
    staticClass: "descBox"
  }, [_c('group', [_c('cell', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d2d2d",
      "font-weight": "bold"
    },
    attrs: {
      "title": "項目詳情",
      "is-link": "",
      "border-intent": false,
      "arrow-direction": "down"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showproDes = !_vm.showproDes
      }
    }
  }), _vm._v(" "), (_vm.showproDes) ? _vm._l((_vm.meetingDetail.contentList), function(item) {
    return _c('img', {
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.canBaoming) ? _c('div', {
    staticStyle: {
      "font-size": "13px",
      "line-height": "25px",
      "padding": "10px",
      "color": "red",
      "text-align": "center"
    }
  }, [_vm._v("此分享會已滿員停止報名，請報名其他場次的分享會。"), _c('p', [_vm._v("谷町君感謝您的支持。")])]) : _vm._e(), _vm._v(" "), (_vm.canBaoming && !_vm.ifproject) ? _c('div', {
    staticClass: "btnFixed"
  }, [_c('div', {
    staticClass: "inputCont"
  }, [_c('div', {
    staticClass: "textsty"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz),
      expression: "biz"
    }],
    staticStyle: {
      "background": "none",
      "font-size": "1.5rem",
      "color": "#2d2d2d",
      "border": "none"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.biz = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teleArr), function(option) {
    return _c('option', {
      domProps: {
        "value": option.intl_tele_code
      }
    }, [_vm._v(_vm._s(option.short_name))])
  }), 0)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "input",
    staticClass: "textInput",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "tel",
      "name": "phoneNum",
      "placeholder": "請輸入手機號"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.totop,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "getmsm",
    on: {
      "click": _vm.applyPhone
    }
  }, [_vm._v("報名")])]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 800,
      "width": "20em",
      "is-show-mask": "",
      "text": _vm.toastText,
      "position": "middle"
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ifproject) ? _c('div', {
    staticClass: "btnFixed"
  }, [_c('div', {
    staticClass: "getmsm",
    staticStyle: {
      "height": "5.6rem",
      "line-height": "5.6rem",
      "width": "100%"
    },
    on: {
      "click": _vm.contactus
    }
  }, [_vm._v("聯繫我們")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 3000,
      "width": "20em",
      "is-show-mask": "",
      "text": _vm.toastText,
      "position": "middle"
    },
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "85%",
      "max-width": "420px"
    },
    attrs: {
      "title": _vm.ifproject ? '填寫聯繫信息' : '報名信息',
      "show-cancel-button": "",
      "confirm-button-text": _vm.ifproject ? '確認提交' : '確認報名',
      "before-close": _vm.beforeClose,
      "confirmButtonColor": "#44c2b8"
    },
    model: {
      value: (_vm.showmeet),
      callback: function($$v) {
        _vm.showmeet = $$v
      },
      expression: "showmeet"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "grey",
      "font-size": "13px",
      "padding": "0 1.3rem",
      "border-bottom": "1px solid #D9D9D9",
      "padding-bottom": "0.8rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v("請填寫您的聯繫信息便於與您取得聯絡，提交後會有專屬顧問聯繫您。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "grey",
      "font-size": "1.5rem",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "80px",
      "margin-left": "15px",
      "font-size": "14px",
      "color": "grey"
    }
  }, [_vm._v("手機號")]), _vm._v(" "), _c('div', {
    staticClass: "textsty",
    staticStyle: {
      "margin-left": "-5px",
      "width": "80px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz),
      expression: "biz"
    }],
    staticStyle: {
      "background": "none",
      "width": "80px",
      "font-size": "14px",
      "color": "#2d2d2d",
      "border": "none"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.biz = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teleArr), function(option) {
    return _c('option', {
      domProps: {
        "value": option.intl_tele_code
      }
    }, [_vm._v(_vm._s(option.short_name))])
  }), 0)]), _vm._v(" "), _c('van-field', {
    staticStyle: {
      "padding": "8px",
      "flex": "1"
    },
    attrs: {
      "type": "tel",
      "border": false,
      "label": "",
      "placeholder": "请輸入手機號"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1), _vm._v(" "), (_vm.condition) ? _c('x-input', {
    staticClass: "weui-vcode",
    staticStyle: {
      "color": "#2d2d2d",
      "font-size": "14px"
    },
    attrs: {
      "show-clear": false,
      "label-width": "70px",
      "placeholder": "請輸入驗證碼"
    },
    on: {
      "on-blur": _vm.totop
    },
    model: {
      value: (_vm.versms),
      callback: function($$v) {
        _vm.versms = $$v
      },
      expression: "versms"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "80px",
      "color": "grey"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("驗證碼")]), _vm._v(" "), (_vm.cansend) ? _c('span', {
    staticStyle: {
      "color": "#44c2b8",
      "font-size": "14px"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.regetcode
    },
    slot: "right"
  }, [_vm._v("重新獲取")]) : _c('span', {
    staticStyle: {
      "color": "grey",
      "font-size": "14px"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.getcodeTxt))])]) : _vm._e(), _vm._v(" "), _c('x-input', {
    staticStyle: {
      "color": "#2d2d2d",
      "font-size": "14px",
      "border-bottom": "1px solid #f0f0f0"
    },
    attrs: {
      "show-clear": false,
      "label-width": "70px",
      "placeholder": "請輸入聯繫人姓名"
    },
    on: {
      "on-blur": _vm.totop
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "80px",
      "color": "grey"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("姓名")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "grey",
      "font-size": "1.5rem",
      "padding": "10px 15px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "display": "inline-block",
      "width": "80px",
      "font-size": "14px",
      "margin-bottom": "6px"
    }
  }, [_vm._v("聯絡方式")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "flex": "1"
    }
  }, [_c('van-radio-group', {
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "direction": "horizontal"
    },
    model: {
      value: (_vm.contacttypeval),
      callback: function($$v) {
        _vm.contacttypeval = $$v
      },
      expression: "contacttypeval"
    }
  }, [_c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 1
    }
  }, [_c('img', {
    staticStyle: {
      "width": "93%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/email.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 2
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/wechat.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 3
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/line.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 4
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/whatsapp.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 9
    }
  }, [_c('img', {
    staticStyle: {
      "width": "96%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/kakao-talk.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-radio', {
    staticStyle: {
      "margin-bottom": "6px",
      "font-size": "1.5rem",
      "width": "5.5rem"
    },
    attrs: {
      "checked-color": "#44c2b8",
      "name": 10
    }
  }, [_c('img', {
    staticStyle: {
      "width": "96%",
      "height": "auto"
    },
    attrs: {
      "src": require("../assets/image/telegram.png"),
      "alt": ""
    }
  })])], 1)], 1)]), _vm._v(" "), (_vm.contacttypelist.length) ? _c('x-input', {
    staticStyle: {
      "color": "#2d2d2d",
      "font-size": "14px"
    },
    attrs: {
      "show-clear": false,
      "label-width": "70px",
      "placeholder": '請填寫您的' + _vm.contacttypelist[_vm.contacttypeval - 1].desc + '賬號'
    },
    on: {
      "on-blur": _vm.totop
    },
    model: {
      value: (_vm.wechat),
      callback: function($$v) {
        _vm.wechat = $$v
      },
      expression: "wechat"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "80px",
      "color": "grey"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.contacttypelist[_vm.contacttypeval - 1].desc) + "賬號")])]) : _vm._e(), _vm._v(" "), (!_vm.ifproject) ? _c('van-cell', [_c('div', {
    staticStyle: {
      "line-height": "60rpx",
      "display": "flex",
      "align-items": "center",
      "color": "grey"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("預訂席位")]), _vm._v(" "), _c('van-stepper', {
    attrs: {
      "max": _vm.maxseat,
      "min": 1
    },
    on: {
      "change": _vm.numChange
    },
    model: {
      value: (_vm.stepNum),
      callback: function($$v) {
        _vm.stepNum = $$v
      },
      expression: "stepNum"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.ifproject) ? _c('van-cell', [_c('div', {
    staticStyle: {
      "color": "#2d2d2d",
      "font-size": "16px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("參會費：" + _vm._s(_vm.meetfee) + "日元  "), _c('van-icon', {
    staticClass: "custom-icon",
    attrs: {
      "slot": "right-icon",
      "size": "20px",
      "color": "#44c2b8",
      "name": "question-o"
    },
    on: {
      "click": _vm.getCostRule
    },
    slot: "right-icon"
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "title": "請微信掃碼支付",
      "show-cancel-button": "",
      "confirm-button-text": "已支付",
      "confirm-button-color": "#44c2b8"
    },
    on: {
      "confirm": _vm.payVerify
    },
    model: {
      value: (_vm.qrcodeshow),
      callback: function($$v) {
        _vm.qrcodeshow = $$v
      },
      expression: "qrcodeshow"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "height": "200px",
      "margin": "10px auto"
    },
    attrs: {
      "id": "qrcodeBox"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "10px",
      "font-size": "14px"
    }
  }, [_vm._v("請求金額：" + _vm._s(_vm.meetfee) + "日元，"), _c('span', {
    staticStyle: {
      "color": "#44c2b8"
    },
    on: {
      "click": _vm.downQrcode
    }
  }, [_vm._v("下載二維碼")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "marginTop": "5px",
      "marginBottom": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": "https://img.gutingjun.com/meeting/meeting_bottom.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44daeec6","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Detail.vue
// module id = 320
// module chunks = 1